import React, { useEffect, useState } from "react";
import Navbar from "./navbar";
import { useNavigate } from "react-router-dom";
import './App.css';
import  './Resources/Actions.css';


export default function Deposits()
{
    const navigate = useNavigate();
    const date = new Date().toISOString().slice(0,10);
    const [prvamount,setPrvamount] = useState([]);
    const [settings, setSettings] = useState([]);
    const [account, setAccount] = useState([]);
    const userid = parseInt(localStorage.getItem("userid")) ;
    
    const API_URL = process.env.REACT_APP_WEB_API_KEY;
    const APP_NAME = process.env.REACT_APP_NAME;

    function sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
      }
    
    useEffect(()=>
    {
    //fetch(API_URL+"api/Dayclosing/DayClosing?date="+ new Date().toISOString().slice(0,10))
    //.then(response => response.json())
    //.then(data => {setPrvamount(data)});   

    fetch(API_URL+"api/Ledger/GetAccounts")
    .then(response => response.json())
    .then(data => {setAccount(data)});

    fetch(API_URL+"api/ReceiptKey/GetCommonSettings")
    .then(res=>res.json())
    .then((data)=>{setSettings(data)})
    },[])      


    function deposit()
    {
        var depositid = settings[0].DepositsID + 1;
        var ddate = document.getElementById("edate").value;
        var dsource = document.getElementById("source").value;
        var damount = document.getElementById("amount").value;
        var commonid = settings[0].CommonID + 1;
      
        const data = new FormData();
        data.append("depositid",depositid);
        data.append("ddate",ddate);
        data.append("dsource",dsource);
        data.append("damount",damount);
        data.append("commonid",commonid);
        data.append("userid",userid);

        fetch(API_URL+"api/Dayclosing/EnterDeposit",{method:"POST",body:data})
        .then(response => response.json())
        .then(() => {});


        fetch(API_URL+"api/Ledger/UpdateDepositsID?id="+depositid,{method:"PUT",body:null})
        .then(response=>response.json())
        .then(()=>{});
        
        showOKdialog();
    
        /*if(prvamount.length > 0 ) 
        {
        
        var amount = prvamount[0].Capital + Number(damount);
        var cno = prvamount[0].C_No;
        console.log(amount);
        const data = new FormData();
        data.append("amount",amount);
        data.append("cno",cno);

        fetch(API_URL+"api/Dayclosing/UpdatePrvBalance",{method:"PUT",body:data})
        .then(response => response.json())
        .then(()=>{});
        }
        else
        {
        const data = new FormData();
        data.append("ddate",ddate);
        data.append("damount", 0);
        data.append("dcamount",damount)

        fetch(API_URL+"api/Dayclosing/EnterDcBalance",{method:"POST",body:data})
           .then(response => response.json())
           .then(()=>{});
        }*/

        
    }

    function ledgerentry()
    {
  
    const amount =parseFloat(document.getElementById('amount').value);
    
    var transid = settings[0].AccTransID + 1;
    const commonid = settings[0].CommonID + 1

    const cashaccount = account.filter((e)=>{if(e.AccountID === 3){return e;}})

    const cashbalance = (cashaccount[0].CurrentDebit+amount)-cashaccount[0].CurrentCredit;
    
    const cashaccountdata = new FormData();

    cashaccountdata.append("entrydate",date);
    cashaccountdata.append("accountdate",date)
    cashaccountdata.append("accountid",cashaccount[0].AccountID)
    cashaccountdata.append("description", "By Capital Account DepositID:  " + (settings[0].DepositsID + 1) );
    cashaccountdata.append("refnumber",("D.NO "+(settings[0].DepositsID + 1)));
    cashaccountdata.append("vouchertype",1);
    cashaccountdata.append("vouchernum",1);
    cashaccountdata.append("dramount",amount);
    cashaccountdata.append("cramount",0);
    cashaccountdata.append("balance",cashbalance);
    cashaccountdata.append("transid",transid);
    cashaccountdata.append("commonid",commonid);
    cashaccountdata.append("userid",userid);


    fetch(API_URL+"api/Ledger/EnterLedger",{method:"POST",body:cashaccountdata})
    .then(response=>response.json())
    .then(()=>{});

    fetch(API_URL+"api/Ledger/UpdateCurrentDebit?id="+cashaccount[0].AccountID+"&amount="+(cashaccount[0].CurrentDebit+amount),{method:"PUT",body:null})
    .then(response => response.json())
    .then(()=>{});


    const capitalaccount = account.filter((e)=>{if(e.AccountID === 1){return e;}})
    const capitalaccbalance = capitalaccount[0].CurrentDebit - (capitalaccount[0].CurrentCredit+amount);
    transid = transid + 1;

    cashaccountdata.set("accountid",capitalaccount[0].AccountID);
    cashaccountdata.set("balance",capitalaccbalance)
    cashaccountdata.set("dramount",0);
    cashaccountdata.set("cramount",amount);
    cashaccountdata.set("transid",transid);
    cashaccountdata.set("description", "To Cash Account DepositID:  " + (settings[0].DepositsID + 1) );
    
    fetch(API_URL+"api/Ledger/EnterLedger",{method:"POST",body:cashaccountdata})
    .then(response=>response.json())
    .then(()=>{});

    fetch(API_URL+"api/Ledger/UpdateCurrentCredit?id="+capitalaccount[0].AccountID+"&amount="+(capitalaccount[0].CurrentCredit+amount),{method:"PUT",body:null})
    .then(response => response.json())
    .then(()=>{});

    fetch(API_URL+"api/Ledger/UpdateAccTransID?id="+transid,{method:"PUT",body:null})
    .then(response=>response.json())
    .then(()=>{});


    fetch(API_URL+"api/Ledger/UpdateCommonID?id="+commonid,{method:"PUT",body:null})
    .then(response=>response.json())
    .then(()=>{});


}


function showOKdialog()
{
  const dialog = document.getElementById('myDialog');
  dialog.showModal();
}

    return(
        <>
        <div className="reportheader"> {APP_NAME}
            
            <Navbar/>
        </div> 
        <div style={{backgroundColor:"goldenrod",height:"25px",width:"100%",textAlign:"center",zIndex:-1,marginBottom:"20px"}}>Deposits</div>
        
        <div>
            <label for = "edate" >Entry Date</label><br/>
            <input id = "edate" type="date" Value = {date} style ={{marginLeft:"1px",width:"96.5%",height: "30px"}} readOnly></input><br/><br/>
            <label for = "source" >Source</label><br/>
            <input id = "source" style ={{marginLeft:"1px",height: "30px",width:"96%"}}></input><br/><br/>
            <label for = "amount" >Deposit Amount</label><br/>
            <input id = "amount" style ={{marginLeft:"1px",height: "30px",width:"96%"}}></input>
        </div>
        
        <div style ={{marginTop:"70px"}}>
        <button type = "button"  className='actionbuttons' onClick={()=>{deposit()}}>Deposit</button> 
        <button type = "button"  className='actionbuttons' style ={{backgroundColor:"red"}} onClick={()=>{navigate('/accounts')}}>Cancel</button>
        </div>
        <dialog id="myDialog" className="okdialog"><p>Deposit Successful</p>
            <button className="okdialogbutton" onClick={()=>{ledgerentry();navigate('/accounts');}}>OK</button>
      </dialog>
        </>

    )
}